import { useEffect, useState } from "react";

/**
 * A ticking "now" so "N min ago" strings stay honest. Also refreshes the
 * moment the tab/PWA becomes visible again — phones throttle timers in the
 * background, and the first thing you want after unlocking is a fresh number.
 */
export function useNow(intervalMs = 20_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const tick = () => setNow(new Date());
    const id = setInterval(tick, intervalMs);
    const onVisible = () => {
      if (document.visibilityState === "visible") tick();
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [intervalMs]);
  return now;
}
